import request from '@/router/axios'
// 获取企业信息列表
export function fetchList(query) {
    return request({
        url: '/complaint/',
        method: 'post',
        params: query
    })
}
// 获取企业信息列表
export function getCompanyInfo(query) {
    return request({
        url: '/platformCompany/info',
        method: 'post',
        params: query
    })
}
// 获取员工信息列表 
export function getWorkerInfo(query) {
    return request({
        url: '/platformCompany/userList',
        method: 'post',
        params: query
    })
}
export function addObj(obj) {
    return request({
        url: '/complaint/replay',
        method: 'post',
        params: obj
    })
}

export function getObj(obj) {
    return request({
        url: '/complaint/info',
        method: 'post',
        params: obj
    })
}
export function getObj1(query) {
    return request({
      url: '/platformWorker/info',
      method: 'post',
      params: query
    })
  }
export function delObj(id) {
    return request({
        url: '/admin/user/' + id,
        method: 'delete'
    })
}

export function putObj(obj) {
    return request({
        url: '/platformUser/update',
        method: 'post',
        params: obj
    })
}
export function selectState(obj) {
    return request({
        url: '/platformCompany/updateStatus',
        method: 'post',
        params: obj
    })
}

// 获取所有角色
export function roleList(query) {
    return request({
        url: '/role/rolePage',
        method: 'post',
        params: query
    })
}

// 停用
export function stop(query) {
    return request({
        url: '/platformUser/updateStatus',
        method: 'post',
        params: query
    })
}
